import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import i18n from "./i18n";
import { initOtel } from "./otel/loader";

const rootElement = document.getElementById("root")!;
const app = (
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// Pages are prerendered in pt-BR at build time (scripts/prerender.mjs); hydrate them instead of
// re-rendering. A visitor who picked English would mismatch, so render from scratch instead.
if (rootElement.hasChildNodes() && i18n.language === "pt-BR") {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

// OTel RUM: só com consentimento de analytics e após o load (ver src/otel/loader.ts).
initOtel();
